import React from "react";
import {
  Avatar,
  Box,
  Card,
  CardContent,
  Stack,
  Typography,
} from "@mui/material";
import ShieldRoundedIcon from "@mui/icons-material/ShieldRounded";

const GaranziaCard = ({ title, description }) => (
  <Card
    sx={{
      borderRadius: 2,
      boxShadow: "0 2px 12px rgba(0,0,0,0.06)",
      border: (theme) =>
        theme.palette.mode === "dark"
          ? "1px solid rgba(255,255,255,0.1)"
          : "1px solid rgba(0,0,0,0.06)",
    }}
  >
    <CardContent sx={{ py: 2.5, px: 3 }}>
      <Stack direction="row" spacing={2} alignItems="center">
        <Avatar
          sx={{
            bgcolor: "rgba(19, 184, 109, 0.12)",
            color: "#13b86d",
            width: 48,
            height: 48,
          }}
        >
          <ShieldRoundedIcon />
        </Avatar>
        <Box>
          <Typography variant="subtitle1" fontWeight={700}>
            {title}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            {description}
          </Typography>
        </Box>
      </Stack>
    </CardContent>
  </Card>
);

export default GaranziaCard;
